import $ from "jquery";

$(document).ready(function () {
  const searchFormElement = $("#navbar-search");
  const navOpenSearchButton = $("#navbar-search > .open-search-button").first();
  const navSearch = $("#navbar-search > .search-input").first();
  const navSearchInputText = $("#navbar-search > .search-input > .search-input__text").first();
  const navSearchInputSubmitButton = $("#navbar-search > .search-input > .search-input__submit-button").first();
  navOpenSearchButton.on("click", onNavOpenSearchButtonClick);
  navSearch.focusin(setTabIndexesToDefault);
  navSearch.focusout(setTabIndexesToIgnore);

  function onNavOpenSearchButtonClick(event: JQuery.Event): void {
    if (!navSearchInputText.is(":focus")) {
      event.preventDefault();
    }
    navSearchInputText.focus();
  }

  function setTabIndexesToDefault(): void {
    searchFormElement.attr("aria-expanded", "true");
    navSearch.attr("aria-hidden", "false");
    navSearchInputText.attr("tabindex", 0);
    navSearchInputSubmitButton.attr("tabindex", 0);
  }

  function setTabIndexesToIgnore(): void {
    searchFormElement.attr("aria-expanded", "false");
    navSearch.attr("aria-hidden", "true");
    navSearchInputText.attr("tabindex", -1);
    navSearchInputSubmitButton.attr("tabindex", -1);
  }
});
